// extracted by mini-css-extract-plugin
export default {"container":"styles_container__P9jkN","link":"styles_link__wGbVo"};